<template>
  <div>
    <div class="bg-white p-3">
      <div class="d-flex justify-content-between">
        <MarketplaceLogo />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useProgressCardStore } from '~/store/progress-card'
import { useIdentityStore } from '~/store/identity';
import MarketplaceLogo from "~/components/marketplace/MarketplaceLogo";

export default {
  name: 'MarketplaceMobileNav',
  components: { MarketplaceLogo },
  setup() {
    return {
      identityStore: useIdentityStore()
    }
  },
  data() {
    return {
      to: 0,
      startProgress: false
    }
  },
  computed: {
    ...mapState(useProgressCardStore, ['marketplaceProgress']),
    progressPercent() {
      return this.startProgress ? this.marketplaceProgress : 0
    }
  },
  mounted() {
    this.startProgress = true
  },
}
</script>

<style lang="scss" scoped></style>
